import { logStore } from "@/logging/logStore";
import { defaultLogRetentionConfig } from "@/logging/config";

export const defaultState = () => {
    return {
        isEnabled: logStore.diagnosticMode,
        maxLogs: defaultLogRetentionConfig.maxEntries,
        logs: []
    }
}

const state = defaultState()
export default state
